import React, { useEffect, useRef } from "react";
import { ActionItem } from "./buildActions";

type ActionDropdownProps = {
  actions: ActionItem[];
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  disabled?: boolean;
};

export const ActionDropdown = ({
  actions,
  open,
  onToggle,
  onClose,
  disabled = false,
}: ActionDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="action-wrapper" ref={dropdownRef}>
      <button className="custom-btn" onClick={onToggle} disabled={disabled}>
        Actions <span>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div className="dropdown-menu">
          {actions.map((action) => (
            <div className="dropdown-item" key={action.actionName}>
              <button
                disabled={action.disabled}
                title={action.title}
                onClick={() => {
                  if (action.disabled) return;
                  action.actionFunction();
                }}
              >
                {action.actionLabel}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
